import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import MainContainer from './pages/Main/MainContainer';
import CheckoutContainer from './pages/Checkout/CheckoutContainer';
import PaymentResultContainer from './pages/PaymentResult/PaymentResultContainer';
import CampaignWrapper from './context/CampaignWrapper';
import OrderContextProvider from './context/OrderContext';

import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-bootstrap-typeahead/css/Typeahead.bs5.css';
import 'react-toastify/dist/ReactToastify.css';
import './assets/styles/scss/customStyles.scss';
import SellerGroupView from './pages/SellerGroup/SellerGroup';
import FinalOrderRedirect from './components/FinalOrderRedirect';
import { TRANSLATED_ROUTES } from './config/i18n';

const App = () => (
  <CampaignWrapper>
    <OrderContextProvider>
      <FinalOrderRedirect />
      <Routes>
        <Route path="/" element={<MainContainer />} />
        <Route path="/:sellerGroupCode" element={<MainContainer />} />
        <Route path="/checkout" element={<CheckoutContainer />} />
        {TRANSLATED_ROUTES.ORDER.map((r) => (
          <React.Fragment key={r}>
            <Route path={`/${r}/:orderId`} element={<PaymentResultContainer />} />
            <Route path={`/${r}/:orderId/:paymentStatus`} element={<PaymentResultContainer />} />
          </React.Fragment>
        ))}
        {TRANSLATED_ROUTES.MEMBER.map((r) => <Route path={`/${r}/:sellerGroupSecret`} element={<SellerGroupView />} key={r} />)}
      </Routes>
      <ToastContainer
        position="bottom-center"
        hideProgressBar
        closeButton={false}
        icon={false}
        limit={3}
      />
    </OrderContextProvider>
  </CampaignWrapper>
);

export default () => (
  <Router>
    <Routes>
      <Route path="/:slug/*" element={<App />} />
    </Routes>
  </Router>
);
